module.exports = __webpack_public_path__ + "static/media/bank-icon.d5311135.png";